// eslint-disable-next-line import/no-anonymous-default-export
const data = [
            {
                "id": "1",
                "img":"glosso.png",
                "github": "https://github.com/amelia2802/glossocure",
                "live":"https://dev.to/amelia2802/a-step-by-step-guide-to-create-a-speaking-practice-app-with-aws-bedrock-59o", 
                "title":"GlossoCure",
                "description":"Mental health wellness web app helping users overcome glossophobia with practice passages and daily confidence tips powered by Claude AI.",
                "skills":["Javascript","Amazon Bedrock","Claude-AI","HTML","CSS"],
                "date": "2024-08-10"
            },
            {
                "id": "2",
                "img":"mock.png",
                "github": "",
                "live":"https://dev.to/amelia2802/create-a-mock-interviewer-bot-with-amazon-lex-v2-dmn", 
                "title":"Mock Interviewer Bot",
                "description":"Mock Interviewer Bot with Amazon Lex",
                "skills":["AWS Lambda","Amazon Lex"],
                "date": "2023-10-10"
            },
            {
                "id": "3",
                "img": "e-comm.png",
                "github":"https://github.com/amelia2802/ice-cream-site",
                "live": "https://luvelicious.netlify.app/",
                "title": "Luvelicious  e-Commerce Site",
                "description": "Fully responsive e-commerce website with dynamic styling and smooth user interactions for an ice cream brand.",
                "skills": ["React", "CSS", "JavaScript"],
                "date": "2024-10-01"
            },
            {
                "id": "4",
                "title": "TorcReads",
                "description":"A full-stack platform solving the Torc community's fragmented book club management. Members can log reading history and access secure study guides.",
                "skills": ["React", "TypeScript", "Tailwind CSS", "Supabase"],
                "github": "https://github.com/jasonetorres/torctoberfest/tree/main/utilities/torcreads",
                "live": "https://torcreads.vercel.app/",
                "img": "projectTorcreads.png",
                "date": "2025-10-10"
  },
]

data.sort((a, b) => new Date(b.date) - new Date(a.date));

export default data;
